module.exports = __webpack_public_path__ + "img/Condominio_das_Americas_SalaoFestas334.16f02032.jpg";